import { CharacterSwatchComponent } from '../character-swatch/character-swatch.component';
import { EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, Input, OnInit, Output, ViewEncapsulation, ViewChild, ElementRef } from '@angular/core';

@Component({
  selector: 'app-character-inspector',
  templateUrl: './character-inspector.component.html',
  styleUrls: ['./character-inspector.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CharacterInspectorComponent implements OnInit {
  @HostBinding('class.char-inspector') charInspector = true;
  @HostBinding('class.has-char') hasChar = false;
  @HostBinding('class.normal') normalClass = true
  @HostBinding('class.show-axes') showAxes = true;

  @ViewChild(CharacterSwatchComponent) swatchComponent: CharacterSwatchComponent;
  public srcSwatch!: CharacterSwatchComponent;
  public categories = '';
  @Input() set src(swatch: CharacterSwatchComponent) {
    if (!swatch) {
      return;
    }
    this.srcSwatch = swatch;
    this.SetData(swatch.info);
    this.cdr.detectChanges();
  }


  private _displaySize?: number;
  @Input('displaySize')
  public set displaySize(size: number) {
    if (this._displaySize === size) return;
    this._displaySize = size;
    this.domNode.nativeElement.style.setProperty('--symbol-size', this.symbolSize);
    this.displaySizeChange.emit(this._displaySize);

    this.Refresh();
  }
  public get displaySize(): number {
    return this._displaySize;

  }
  @Output() displaySizeChange = new EventEmitter<number>();

  public get symbolSize(): string {
    return this.displaySize + 'pt';;
  }
  public get symbolPxSize(): number {
    return Math.round((this.displaySize / 1.33));
  }
  private _name = '';
  public set name(inName: string) {
    this._name = inName;

  }
  public get name(): string {
    return this._name;
  }
  public tags = '';
  @Input() data!: any;
  @Output() dataChange = new EventEmitter<any>();
  @ViewChild(CharacterSwatchComponent, { static: true }) preview!: CharacterSwatchComponent;
  public font: string = '';
  @Input() set fontName(name: string) {
    this.font = name;
    this.Refresh();

  };
  public textColor: string = '#000';
  @Input() set color(inColor: string) {
    this.textColor = inColor;
    this.Refresh();
  }

  private _xOffset: number = 0;
  public get xOffset(): number {
    return this._xOffset;
  }
  public set xOffset(offset: number) {
    if (isNaN(offset)) return;
    this._xOffset = offset;
    this.swatchComponent.element.style.setProperty('--symbol-offset-x', offset + 'px');
    this.Refresh();
  }

  public get symbolCode(): string {
    if(!this.srcSwatch) return '';
    return this.srcSwatch.codeText;
  }

  private _yOffset = 0;
  public get yOffset(): number {
    return this._yOffset;
  }
  public set yOffset(offset: number) {
    if (isNaN(offset)) return;
    this._yOffset = offset;
    this.swatchComponent.element.style.setProperty('--symbol-offset-y', this._yOffset + 'px');
    this.Refresh();
  }
  private _rotation = 0;
  public get rotation(): number {
    return this._rotation;
  }
  @Input()
  public set rotation(theta: number) {
    if (isNaN(theta)) return;
    this._rotation = theta;
    this.swatchComponent.element.style.setProperty('--symbol-rotation', this._rotation + 'deg');
    this.Refresh();
  }

  public codeText = '';
  public codePoint = 0;
  public codeHTML = '';
  constructor(private cdr: ChangeDetectorRef, private domNode: ElementRef<HTMLDivElement>) { }

  public get swatchWidth(): string {
    if (!this.swatchComponent) return '';
    return this.swatchComponent.width;
  }

  public get swatchHeight(): string {
    if (!this.swatchComponent) return '';
    return this.swatchComponent.height;
  }

  SetData(data?: any) {
    this.data = data;
    this.name = (!!this.data.name) ? this.data.name : this.data.code;
    this.tags = (!!this.data.tags) ? this.data.tags.join(' ') : '';
    this.categories = (!!this.data.categories) ? this.data.categories.join(', ') : '';
    this.codeText = this.data.code.toString(16).padStart(4, '0').toUpperCase();
    this.codePoint = this.data.code;
    this.codeHTML = `&#x${this.codeText};`;
    this.hasChar = (!!this.codePoint);
    this.Refresh();

  }
  HandleChange() {
    this.data.name = this.name;
    const tags = this.tags.trim().split(' ');
    tags.every((value, index, data) => {
      value = value.trim().replace('#', '');
      data[index] = value;
      return true;
    });
    tags.sort();
    this.data.tags = tags;
    const categories = this.categories.trim().split(',');
    categories.every((value, index, src) => { value = value.trim(); src[index] = value; return true; });
    this.data.categories = categories.sort();
    if (this.preview) {
      this.preview.charInfo = this.data;

    }
    this.dataChange.emit(this.data);
    this.SetData(this.data);


  }

  ngOnInit(): void {
    this._ready = true;
    this.displaySize = 12;
    this.Refresh();
  }
  private _ready = false;
  Refresh() {
    if (!this._ready) return;
    window.requestAnimationFrame(() => {
      this.domNode.nativeElement.style.setProperty('--swatch-width', this.swatchWidth);
      this.domNode.nativeElement.style.setProperty('--swatch-height', this.swatchHeight);


    });
    this.cdr.detectChanges();
  }

}
